export function changepostoBicosVazao(value) {
  return {
    type: '@locomotivaRegistration/LOCACOMOTIVA_POSTOBICOSVAZAO',
    payload: { value },
  };
}

export function resetValues() {
  return {
    type: '@locomotivaRegistration/LOCACOMOTIVA_RESETVALUES',
  };
}
